import baseAPI from '@/api/base';
import { EditEmployeeAllowance, GetEmployeeAllowance, RegisterEmployeeAllowance } from '@/dtos/employee_allowance.dto';
import {
  DELETE_EMPLOYEE_ALLOWANCE_URL,
  EDIT_EMPLOYEE_ALLOWANCE_URL,
  GET_EMPLOYEE_ALLOWANCE_URL,
  REGISTER_EMPLOYEE_ALLOWANCE_URL,
  TOGGLE_EMPLOYEE_ALLOWANCE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class EmployeeAllowance {
  static getEmployeeAllowances = async (getEmployeeAllowance: GetEmployeeAllowance): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_EMPLOYEE_ALLOWANCE_URL, {
      params: getEmployeeAllowance,
    });
    console.log('response', response);
    return response;
  };

  static registerEmployeeAllowance = async (
    registerEmployeeAllowance: RegisterEmployeeAllowance
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_EMPLOYEE_ALLOWANCE_URL, {
      ...registerEmployeeAllowance,
    });
    console.log('response', response);
    return response;
  };

  static editEmployeeAllowance = async (editEmployeeAllowance: EditEmployeeAllowance): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_EMPLOYEE_ALLOWANCE_URL, {
      ...editEmployeeAllowance,
    });
    return response;
  };

  static toggleEmployeeAllowanceIsActive = async (
    editEmployeeAllowance: EditEmployeeAllowance
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_EMPLOYEE_ALLOWANCE_IS_ACTIVE_URL,
      {
        ...editEmployeeAllowance,
      }
    );
    return response;
  };

  static deleteEmployeeAllowance = async (userId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_EMPLOYEE_ALLOWANCE_URL}/${userId}`
    );
    return response;
  };
}

export default EmployeeAllowance;
